import React from "react"
import type { MouseEvent, PropsWithChildren } from "react"
import clsx from "classnames"

interface ButtonProps {
  style?: "primary" | "secondary"
  disabled?: boolean
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
}

/**
 * Button implementation, following the UI v3 design system.
 */
export const Button = ({
  children,
  onClick,
  style = "primary",
  disabled = false,
  ...rest
}: PropsWithChildren<ButtonProps>) => {
  return (
    <button
      className={clsx("rounded-full border border-solid border-black px-6 py-2 font-semibold", {
        "bg-black text-white": style === "primary",
        "bg-white text-black": style === "secondary",
        "cursor-pointer hover:border-gray-700 hover:bg-gray-700 hover:text-white": !disabled,
        "cursor-not-allowed opacity-50": disabled,
      })}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  )
}
